// 業務報告書
$(() => {
    if (document.getElementById('client-report-form') != null) {
        $('.modal-exec').click(function(){
            $('#approval_comment').val($('#modal_approval_comment').val());
            $('#approval').submit();
        });

        $('.remand-exec').click(function(){
            $('#remand_comment').val($('#modal_remand_comment').val());
            $('#remand').submit();
        });

        $('.reapplication-exec').click(function(){
            $('#reapplication').submit();
        });

        $('.forcibly-exec').click(function(){
            $('#forcibly').submit();
        });

        // アンケートスタート画面
        // 登録画面へ遷移
        $('#toSurveyFormModal').on('click', function () {
            $('#surveyStartModal').modal('hide');
            $('#surveyFormModal').modal('show');
        });

        // アンケート登録画面
        // 登録したのち検収画面へ遷移
        $('#toCommonModal').on('click', function () {
            let surveyId = $('input[name=survey_id]').val();

            // リクエストパラメータ生成
            let params = {};
            let serialized = $('#surveyForm').serializeArray();
            $.each(serialized, function (_, paramMap) {
                // "answer_add"を除外
                if (paramMap.name.indexOf('[answer_add]') !== -1) {
                    return true;
                }
                // "answer_add"があれば上書き
                if (paramMap.name.indexOf('[answer]') !== -1) {
                    // "answer_add"を探索し、存在すれば値を変更
                    let targetName = paramMap.name.replace('[answer]', '[answer_add]');
                    let targetParamMap = serialized.find(function (paramMap) {
                        return paramMap.name === targetName;
                    });
                    if (targetParamMap !== undefined) {
                        params[paramMap.name] = targetParamMap.value;
                        return true;
                    }
                }
                params[paramMap.name] = paramMap.value;
            });

            // アンケート送信
            $.ajax({
                url: '/client/ajax/surveys/' + surveyId,
                type: 'POST',
                dataType : 'json',
                data: params
            }).done(function() {
                return true;
            }).fail(function() {
                return false;
            }).always(function () {
                // モーダル遷移
                $('#surveyFormModal').modal('hide');
                $('#endSurvey_modal').modal('show');
                // 検収ボタンのdata-targetを書き換える
                $('#approveButton').attr('data-target', '#common_modal');
            });
        });

        // アンケート登録画面
        // 追加質問の表示操作
        $('.survey-answer-base').on('change', function () {
            let matches = $(this)
                .attr('id')
                .match(/^answer(.)\[(\d+)\]$/);
            let inputNum = matches[1];
            let groupIndex = matches[2];
            let target = $('#surveyAddRadioGroup' + groupIndex);
            if (inputNum === 'x') {
                target.collapse('show');
            } else {
                target.collapse('hide');
                // 追加質問の回答をクリア
                $('input[name="data[' + groupIndex + '][answer_add]"]:checked').prop('checked', false);
            }
        });

        // アンケート登録画面
        // ラジオボタンの状態で回答ボタンを有効/無効化
        $('.survey-answer').on('change', function () {
            // 各ラジオグループごとに一つでもチェックされているか確認
            let existsOff  = false;
            $('.survey-radio-group').each(function (index) {
                // NOTE: 「回答できない」ボタンはvalueが空文字列のため、チェック済扱いにならない
                if (!$('input[name="data[' + index + '][answer]"]:checked').val()
                    && !$('input[name="data[' + index + '][answer_add]"]:checked').val()) {
                    existsOff = true;
                }
            });
            // 回答ボタンの有効化/無効化
            $('#toCommonModal').prop('disabled', existsOff);
        });

        // アンケート登録画面
        // テキストエリアのバリデーション
        $('.survey-reason').on('change', function () {
            // NOTE: 改行コードを2文字扱いでカウントする
            let text = $(this).val().replace('\n', 'ee');
            if (text.length > 1000) {
                $(this).addClass('is-invalid');
                $(this).parent().find('#surveyReasonError').collapse('show');
            } else {
                $(this).removeClass('is-invalid');
                $(this).parent().find('#surveyReasonError').collapse('hide');
            }
        });
    }
});
